import { motorNaoTratado, type Motor } from '@remoto/protocolo';

/**
 * O aviso do compositor quando há imagem na fila — ou `null` quando não há o
 * que avisar.
 *
 * **D23 revista (2026-09-24), medida:** o DeepSeek V4.1 Flash diz `image: true`
 * no catálogo e, pelo OpenRouter, responde que não vê imagem nenhuma. Por isso
 * o clipe do OpenCode aparece SEMPRE, e o turno com imagem vai sozinho ao
 * modelo de visão da frota (`modeloDoTurnoComImagem`): só aquele turno, e a
 * sessão continua no modelo dela. Esconder o clipe pelo catálogo deixaria
 * passar justamente o modelo que mente.
 *
 * O nome do modelo de visão NÃO entra na frase: ele mora na configuração, que
 * só ADMIN lê, e a frase vale para quem não é. Dizer que a troca existe é o
 * que a pessoa precisa para não estranhar a resposta.
 */
export function avisoDeImagemDoMotor(motor: Motor): string | null {
  switch (motor) {
    case 'CLAUDE':
    case 'CODEX':
      return null;
    case 'OPENCODE':
      return 'Com imagem, este turno é lido pelo modelo de visão da frota; a sessão continua no modelo dela.';
    default:
      return motorNaoTratado(motor);
  }
}
